module.exports = __webpack_public_path__ + "img/391db60.jpg";